import React from 'react'
import '../styles/RightWindow.css'

const RightWindow = ({children, show}) => {
  return (
    <div className={`RightWindow ${show ? 'unHideR': 'hideR'}`}>
        <div className="RWcontainer">
            {children}
        </div>
    </div>
  )
}

export default RightWindow